import React from 'react';
import { Avatar, Tooltip } from '@mui/material';
import { useAuth } from '../../../store/AuthContext';

const getInitials = (name: string | null) => {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  const initials = parts.slice(0, 2).map((part) => part[0]?.toUpperCase() || '');
  return initials.join('') || '?';
};

export const AdminAvatar: React.FC = () => {
  const { authState } = useAuth();

  return (
    <Tooltip title={authState.userName || 'Admin'}>
      <Avatar
        sx={{
          width: 36,
          height: 36,
          bgcolor: '#7B1FA2',
          fontSize: 14,
          fontWeight: 700,
        }}
      >
        {getInitials(authState.userName)}
      </Avatar>
    </Tooltip>
  );
};
